module.exports = __webpack_public_path__ + "static/media/clause-library.2c6779a9.svg";